import React from "react";
import styled from "styled-components";
import { Tabs, Tab, Paper, Box, Typography } from "@mui/material";
import TabContent from "./TabContent";
import TooltipIconButton from "components/TooltipIconButton";
import { Close } from '@mui/icons-material';
import CodeIcon from "components/CustomIcons/CodeIcon";

const BoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ActionGroups = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Typography)`
  &.MuiTypography-root {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #e5e5e5;
    font-family: "Roboto", sans-serif;
  }
`;
const Wrapper = styled(Paper)`
  &.MuiPaper-root {
    background-color: #2f2f2f;
  }
`;
const CustomTabs = styled(Tabs)`
  .MuiTabs-flexContainer {
    align-items: center;
    justify-content: space-between;
  }
  .MuiTabs-indicator {
    background-color: #287bf2;
  }
`;
const CustomTab = styled(Tab)`
  &.MuiTab-root {
    color: #a0a0a0;
    font-size: 15px;
    font-weight: 700;
    font-family: "Roboto", sans-serif;
    line-height: 19px;
    text-transform: none;
    min-width: unset;
    padding: 0;
    &.Mui-selected {
      color: #ffffff;
    }
    &:focus {
      outline: none;
    }
  }
`;

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`metadata-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `metadata-tab-${index}`,
    "aria-controls": `metadata-tabpanel-${index}`,
  };
};

const Content = (props) => {
  const { info, handleToggleModal } = props;
  const [tabValue, setTabValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Wrapper square>
      <Box px="25px" pt="26px" pb="12px" width="100%">
        <BoxHeader>
          <Title>Request Information</Title>
          <ActionGroups>
            {/* <TooltipIconButton title="API Endpoint" ariaLabel="api" placement="bottom" size={44}>
              <CodeIcon />
            </TooltipIconButton> */}
            <TooltipIconButton title="Close" ariaLabel="close" placement="bottom" onClick={handleToggleModal} size={44}>
              <Close />
            </TooltipIconButton>
          </ActionGroups>
        </BoxHeader>
        {/* <CustomTabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        // variant="fullWidth"
        >
          {Object.keys(info).map((item, index) => (
            <CustomTab label={item} {...a11yProps(index)} key={index} />
          ))}
        </CustomTabs> */}
      </Box>
      <Box>
        {/* {Object.keys(info).map((item, index) => (
          <TabPanel value={tabValue} index={index} key={index}>
            <TabContent tabInfo={info[item]} />
          </TabPanel>
        ))} */}
        <TabContent tabInfo={info} />
      </Box>
    </Wrapper>
  );
};

export default Content;
